maskSelectionSet